import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import Portal from 'components/Modals/MainPortal';
import SideMenu from 'components/SideMenu';
import { FiMenu } from 'react-icons/fi';
import HeaderAccount from 'components/HeaderAccount';
import { useDispatchApp } from 'redux/rootSelectors';
import { setHideNavigation } from 'domains/user/reduser';
import { useProjectTheme } from 'domains/project/model/selectors';
import NotificationPanel from 'components/NotificationPanel';
import { NotificationInitializer } from 'utils/NotificationInitializer';
import { useProjectInfo } from '../../domains/project/hooks';
import UserList from '../../domains/wss/UI/UserList';
import {
  useHideNavigation,
  useUserInfo,
} from '../../domains/user/model/selectors';
import Balance from '../Balance';
import { usePartnerBalance } from '../Balance/hooks/usePartnerBalance';
import css from './styles.module.scss';

const BlackHeader: FC = () => {
  const hideNavigation = useHideNavigation();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatchApp();
  const onClose = () => setOpen(false);
  const { data: project } = useProjectInfo();
  const { data: user } = useUserInfo();
  const { value, currency, handleFetcher, isLoading, name } =
    usePartnerBalance();
  const isNewYear = useProjectTheme();

  useEffect(() => {
    if (user?.group.length === 0) {
      dispatch(setHideNavigation(true));
    }
  }, [user?.group.length]);

  return (
    <>
      <div
        className={cn(css.black__header, {
          _isNewYear: isNewYear,
        })}
      >
        <div className={css.black__header_content}>
          <div className={css.black__header__left}>
            {!hideNavigation && (
              <button
                type="button"
                className={css.black__header_menu}
                onClick={() => setOpen(true)}
              >
                <FiMenu />
              </button>
            )}
            {project && project.logo_small && (
              <Link to="/main" className={css.black__header_logo}>
                <img src={project.logo_small} alt="logo" />
              </Link>
            )}
          </div>
          <div className={css.black__header_right}>
            <UserList />
            <Balance
              value={value && Math.floor(value)}
              currency={currency}
              fetcher={handleFetcher}
              classname={css.black__header_balance}
              name={name}
              isTooltip
              isLoading={isLoading}
            />
            <HeaderAccount />
            <NotificationPanel />
            <NotificationInitializer />
          </div>
        </div>
      </div>
      <Portal>
        <SideMenu onClose={onClose} isOpen={open} />
      </Portal>
    </>
  );
};

export default BlackHeader;
